import PropTypes from 'prop-types'
import styled from 'styled-components'

import colors from '../../constants/colors'

export const Wrapper = styled.div`
    width: 100%;
    height: 75px;
`

export const LabelWrapper = styled.label`
    display: inline-block;
    margin-bottom: 0.5rem;
    width: 100%;
`

export const Label = styled.div`
    width: 100%;
    height: 22px;
    font-size: 16px;
    transition: all 0.3s;
    -webkit-transition: all 0.3s;
    z-index: 3;
    position: relative;
    top: 30px;
    cursor: text;
    font-size: 20px;
    color: ${colors.grey};

    ${({ focused }) =>
        focused &&
        `
    color: ${colors.blue};
    font-size: 18px;
    top: 0px;
    left: 0px;
  `}
`

Label.propTypes = {
    focused: PropTypes.bool,
}

Label.defaultProps = {
    focused: false,
}

export const Input = styled.input`
    color: #212529;
    z-index: 2;
    outline: 0;
    width: 100%;
    padding: 10px 15px;
    margin: 0 auto;
    display: block;
    font-size: 18px;
    transition-duration: 0.25s;
    font-weight: 300;
    background: none;
    border: 0;
    border-bottom: 1px solid ${colors.greylight};

    &:focus {
        border-bottom: 1px solid ${colors.bluelight};
    }

    ${({ danger }) => danger && `border-bottom: 1px solid ${colors.red};`}
`

Input.propTypes = {
    danger: PropTypes.bool,
}

Input.defaultProps = {
    danger: false,
}

export const Info = styled.div`
    color: ${colors.grey};
    text-align: right;
    font-size: 14px;

    ${({ danger }) => danger && `color: ${colors.red};`}
`

Info.propTypes = {
    danger: PropTypes.bool,
}

Info.defaultProps = {
    danger: false,
}
